import { useNavigation } from "@react-navigation/native";
import { useCallback } from "react";

import { CalloutRefresh, IdentityForm } from "../components";
import { useUser } from "../services";
import { LoadingScreen } from "./loading";

export function IdentityScreen() {
  // Data
  const {
    data: user,
    isLoading: isUserLoading,
    refetch: refetchUser,
  } = useUser();

  // Vars
  const navigation = useNavigation();

  // Methods
  const goToVerifyIdentity = useCallback(() => {
    navigation.navigate("VerifyIdentity");
  }, [navigation]);

  // Handlers
  const handleSuccess = useCallback(() => {
    alert("Identity updated successfully!");

    navigation.goBack();
  }, [navigation]);

  // Render
  if (isUserLoading) {
    return <LoadingScreen />;
  }

  if (!user) {
    return <CalloutRefresh onRefresh={refetchUser} />;
  }

  return (
    <IdentityForm
      user={user}
      onSuccess={handleSuccess}
      onVerifyIdentity={goToVerifyIdentity}
    />
  );
}
